"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../../BaseAvroRecord");
class Tab extends BaseAvroRecord_1.BaseAvroRecord {
    schema() {
        return Tab.schema;
    }
    subject() {
        return Tab.subject;
    }
}
exports.Tab = Tab;
Tab.subject = "tab";
Tab.schema = {
    "type": "record",
    "name": "Tab",
    "namespace": "storyblocks.common.frontend",
    "fields": [
        {
            "name": "isNewTab",
            "type": "boolean"
        },
        {
            "name": "tabCount",
            "type": "int"
        },
        {
            "name": "tabId",
            "type": "string"
        }
    ]
};
//# sourceMappingURL=Tab.js.map